__turbopack_context__.v({
  "banner": "H9xbjq_banner",
  "button": "H9xbjq_button",
  "loginButton": "H9xbjq_loginButton",
  "subtitle": "H9xbjq_subtitle",
  "title": "H9xbjq_title",
});
